<template>
  <div class="col-12" style="padding: 0px">
    <div class="card">
        <div class="card-header">
            <h5>
                <i class="fa fa-users"></i>
                ادارة المعلمين
                <button class="btn btn-sm btn-primary" style="padding: 5px; border-radius: 0px" v-b-modal.create>
                    <i class="fa fa-plus"></i>
                     اضافة معلم
                </button>
                <b-modal id="create" title="اضافة" hide-footer>
                    <div class="form-group">
                      <h5 for="">اسم المعلم</h5>
                      <input type="text"
                        class="form-control" v-model="create.name" aria-describedby="helpId" placeholder="اكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">جوال المعلم</h5>
                      <input type="text"
                        class="form-control" v-model="create.phone" aria-describedby="helpId" placeholder="اكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">اسم المستخدم (للدخول لتطبيق الجوال)</h5>
                      <input type="text"
                        class="form-control" v-model="create.username" aria-describedby="helpId" placeholder="اكتب هنا...">
                    </div>
                    <div class="form-group">
                      <h5 for="">كلمة المرور (للدخول لتطبيق الجوال)</h5>
                      <input type="text"
                        class="form-control" v-model="create.password" aria-describedby="helpId" placeholder="اكتب هنا...">
                    </div>
                    <div class="col-12 text-center g">
                        <button class="btn btn-primary" @click="add()">
                            <i class=" fa fa-check"></i>
                            اضافة المعلم 
                        </button>
                    </div>
                </b-modal>
                &nbsp;
                <button class="btn btn-sm btn-warning" @click="print()" style="padding: 5px; border-radius: 0px">
                    <i class="fa fa-print"></i>
                     طباعة بيانات المعلمين
                </button>
                &nbsp;
                <button class="btn btn-sm btn-outline-success" style="padding: 5px; border-radius: 0px" @click="fromTahdir()">
                    <img :src="require('@/assets/images/ai.png')" width="12">
                     اضافة المعلمين من التحضير الذكي
                </button>
            </h5>
        </div>
        <div class="card-body">
            <b-modal id="edit" title="تعديل" hide-footer>
                <div class="form-group">
                    <h5 for="">اسم المعلم</h5>
                    <input type="text"
                    class="form-control" v-model="edit.name" aria-describedby="helpId" placeholder="اكتب هنا...">
                </div>
                <div class="form-group">
                    <h5 for="">جوال المعلم</h5>
                    <input type="text"
                    class="form-control" v-model="edit.phone" aria-describedby="helpId" placeholder="اكتب هنا...">
                </div>
                <div class="form-group">
                    <h5 for="">اسم المستخدم (للدخول لتطبيق الجوال)</h5>
                    <input type="text"
                    class="form-control" v-model="edit.username" aria-describedby="helpId" placeholder="اكتب هنا...">
                </div>
                <div class="form-group">
                    <h5 for="">كلمة المرور (للدخول لتطبيق الجوال)</h5>
                    <input type="text"
                    class="form-control" v-model="edit.password" aria-describedby="helpId" placeholder="اكتب هنا...">
                </div>
                <div class="form-group" v-if="edit._id">
                    <h5 for="">نصاب الحصص الاسبوعي</h5>
                    <input type="text"
                    class="form-control" v-model="edit.config.max_lessons" aria-describedby="helpId" placeholder="اكتب هنا...">
                </div>
                <div class="col-12 text-center g">
                    <button class="btn btn-primary" @click="editNow()">
                        <i class=" fa fa-check"></i>
                        تعديل المعلم 
                    </button>
                </div>
            </b-modal>
            <div class="col-12 table-responsive" style="padding: 0px">
                <table class="table table-striped table-sm table-hover table-bordered">
                    <thead>
                        <th>
                            الاسم
                        </th>
                        <th>
                            اسم المستخدم
                        </th>
                        <th>
                            إسناد المواد
                        </th>
                        <th>
                            حذف
                        </th>
                    </thead>
                    <tbody>
                        <b-modal id="assigns" title="اختيار المواد" hide-footer size="xl">
                            <template v-if="current._id">
                                <div class="col-12 text-center g" @click="saveAssigns()">
                                    <button class="btn btn-primary">
                                        <i class="fa fa-check"></i>
                                        حفظ الاختيارات
                                    </button>
                                </div>
                                <div class="col-12 col-lg-4 c g border">
                                    <h1>النصاب الحالي: {{ current.subjects_items }}</h1>
                                    <small>يتم التحديث بعد الحفظ</small>
                                </div>
                                <div style="padding: 0px" class="col-12 table-responsive">
                                    <table class="table table-hover table-bordered table-sm table-striped">
                                        <thead>
                                            <th>
                                                الفصل
                                            </th>
                                            <th>
                                                اختيار المواد
                                            </th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="c in classrooms" :key="c._id">
                                                <td>
                                                    {{ c.classname }} ~
                                                    {{ c.title }}
                                                </td>
                                                <td>
                                                    <template v-for="s in getSubjectsObj(c)">
                                                        <button :key="s._id" v-if="selectedSubject[c._id+','+s._id] && selectedSubject[c._id+','+s._id] != current._id" class="btn-sm btn-outline-default disabled" disabled>
                                                            <i class="fa fa-lock"></i>
                                                            {{ s.title }}
                                                            <br>
                                                            <small>{{ teacherName(selectedSubject[c._id+','+s._id]) }}</small>
                                                        </button>
                                                        <button v-if="!selectedSubject[c._id+','+s._id] || selectedSubject[c._id+','+s._id] == current._id" :key="s._id" :class="' btn-sm ' + (current.assigns.includes(c._id + ',' + s._id) ? 'btn-primary' : 'btn-outline-primary')" @click="current.assigns.includes(c._id + ',' + s._id) ? current.assigns = current.assigns.filter(function(x){
                                                            if(x == c._id + ',' + s._id){
                                                                return false;
                                                            }else{
                                                                return x
                                                            }
                                                        }) : current.assigns.push(c._id + ',' + s._id)" style="border-radius: 0px; margin-left: 2px;">
                                                            {{ s.title }}
                                                        </button>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                        </b-modal>
                        <tr v-for="teacher in teachers" :key="teacher._id">
                            <td>
                                {{ teacher.name }}
                            </td>
                            <td>
                                {{ teacher.username }}
                            </td>
                            <td>
                                <button class="fa fa-edit btn btn-sm btn-primary" v-b-modal.assigns @click="current = teacher" title="تعديل" style="padding: 5px; border-radius: 50%"></button> ({{ teacher.assigns.length }} محددة)
                            </td>
                            <td>
                                <button class="btn btn-sm btn-primary" style="border-radius: 0px; padding: 5px" @click="edit = teacher" v-b-modal.edit>
                                    <i class="fa fa-edit"></i>
                                    تعديل
                                </button>
                                <button class="btn btn-sm btn-danger" style="border-radius: 0px; padding: 5px" @click="deleteTeacher(teacher._id)">
                                    <i class="fa fa-trash"></i>
                                    حذف
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <table class="table table-sm table-bordered table-hover">
                <thead>
                    <th>
                        المعلم
                    </th>
                    <th>
                        الصفوف التي يدرسها
                    </th>
                    <th>
                        المواد
                    </th>
                    <th>
                        عدد الحصص الاسبوعي
                    </th>
                </thead>
                <tbody>
                    <template v-for="teacher in teachers">
                        <tr v-for="(t, tx) in teachertt(teacher)" :key="tx">
                            <td>
                                {{ teacher.name }}
                            </td>
                            <td>
                                {{ t.classroom }}
                            </td>
                            <td>
                                {{ t.subject }}
                            </td>
                            <td>
                                {{ t.count }}
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
function makeid(length) {
    let result = '';
    const characters = 'abcdefghkmnoprstuvwxyz123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}
import { VBModal, BModal, BFormInput, BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
    components: {
        // Layouts
        BDropdown, BDropdownItem,
        BModal,BFormInput},
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            user: JSON.parse(localStorage.getItem("user")),
            teachers: [],
            edit: {},
            create: {
                username: Math.random().toString().split(".")[1].substring(0,6).replace("0", "1"),
                password: makeid(5),
            },
            classrooms: [],
            current: {},
            subjects_obj: {},
            subjects: [],
            selectedSubject: {},
        }
    },
    created(){
        var g = this;
        g.getTeachers();
        $.post(api + '/user/classrooms/list', {
            jwt: g.user.jwt
        }).then(function(r){
            if(r.status != 100){
                alert(r.response, 200)
            }else{
                g.classrooms = r.response;
            }
        }).fail(function(){
            alert('حدث خطأ في الاتصال', 200)
        })
        g.getSelectedSubjects()
        $.post(api + '/user/subjects/list', {
            jwt: g.user.jwt
        }).then(function(r){
            if(r.status != 100){
                alert(r.response, 200)
            }else{
                r.response.forEach(function(x){
                    g.subjects_obj[x._id] = x;
                })
                g.subjects = r.response
            }
        }).fail(function(){
            alert('حدث خطأ في الاتصال', 200)
        })
    },
    methods: {
        teachertt(teacher){
            var g = this;
            var text = [];
            teacher.assigns.forEach(function(a){
                if(g.subjectObj(a.split(",")[1]) && g.classroomObj(a.split(",")[0]) && g.subjectObj(a.split(",")[1]).single_lessons && g.subjectObj(a.split(",")[1]).title && g.classroomObj(a.split(",")[0]).title){
                    text.push({
                        classroom: g.classroomObj(a.split(",")[0]).title,
                        subject: g.subjectObj(a.split(",")[1]).title,
                        count: g.subjectObj(a.split(",")[1]).single_lessons
                    })
                }
            })
            return text;
        },
        getSelectedSubjects(){
            var g = this;
            $.post(api + '/user/teachers/selected-subjects', {
                jwt: g.user.jwt
            }).then(function(r){
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.selectedSubject = r.response;
                }
            }).fail(function(){
                alert('حدث خطأ في الاتصال', 200)
            })
        },
        fromTahdir(){
            var g = this;
            if(confirm("متأكد من استيراد بيانات المعلمين من نظام التحضير الذكي؟")){
                $.post(api + '/user/teachers/from-tahdir', {
                    jwt: g.user.jwt
                }).then(function(r){
                    if(r.status != 100){
                        alert(r.response, 200)
                    }else{
                        g.getTeachers()
                    }
                }).fail(function(){
                    alert('حدث خطأ في الاتصال', 200)
                })
            }
        },
        teacherObj(id){
            var n = {};
            var g = this;
            g.teachers.forEach(function(a){
                if(a._id == id){
                    n = a;
                }
            })
            return n;
        },
        classroomObj(id){
            var n = {};
            var g = this;
            g.classrooms.forEach(function(a){
                if(a._id == id){
                    n = a;
                }
            })
            return n;
        },
        subjectObj(id){
            var n = {};
            var g = this;
                console.log(g.subjects)
            g.subjects.forEach(function(a){
                if(a._id == id){
                    n = a;
                }
            })
            return n;
        },
        teacherName(id){
            var n = "";
            var g = this;
            g.teachers.forEach(function(a){
                if(a._id == id){
                    n = a.name;
                }
            })
            return n;
        },
        print(){
            var g = this;
            var win = window.open();
            var html = "";
            g.teachers.forEach(function(a, i){
                html = html + `
                <tr>
                    <td>${i+1}</td>
                    <td>${a.name}</td>
                    <td>${a.username}</td>
                    <td>${a.password}</td>
                </tr>
                `
            })
            win.document.write(`
            <html dir='rtl'>
            <head>
                <style>
                    @page{
                        margin: 0px;
                        padding: 0px
                    }
                        table, td, th {
                        border: 1px solid;
                        padding: 10px
                    }

                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    td{
                        text-align: center
                    }
                    thead th{
                        background: #FFF6DA !important
                    }
                </style>
            </head>
            <body>
                <table>
                    <thead>
                        <th>م</th>
                        <th>المعلم</th>
                        <th>اسم المستخدم</th>
                        <th>كلمة المرور</th>
                    </thead>
                    <tbody>
                        ${html}
                    </tbody>
                </table>
            </body>
            </html>
            `)
            win.document.close();
            win.print()
            win.close()
        },
        deleteTeacher(id){
            if(confirm("متأكد من حذف المعلم؟")){
                var g = this;
                $.post(api + '/user/teachers/delete', {
                    jwt: g.user.jwt,
                    id: id
                }).then(function(r){
                    g.getTeachers()
                }).fail(function(){
                    alert('حدث خطأ في الاتصال', 200)
                })
            }
        },
        saveAssigns(){
            var g = this;
            $.post(api + '/user/teachers/save-assigns', {
                jwt: g.user.jwt,
                id: g.current._id,
                assigns: JSON.stringify(g.current.assigns)
            }).then(function(r){
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.getTeachers()
                    $("#assigns___BV_modal_header_ > button").click()
                    g.getSelectedSubjects()
                }
            }).fail(function(){
                alert('حدث خطأ في الاتصال', 200)
            })
        },
        getSubjectsObj(c){
            var g = this;
            var xx = c.subjects.map(function(x){return g.subjects_obj[x]});
            function compare( a, b ) {
            if ( a.title < b.title ){
                return 1;
            }
            if ( a.title > b.title ){
                return -1;
            }
            return 0;
            }

            xx.sort( compare );
            return xx;
        },  
        add(){
            var g = this;
            if(!g.create.name || g.create.name == ""){
                return alert("برجاء كتابة اسم المعلم", 200);
            }
            if(!g.create.username || g.create.username == ""){
                return alert("برجاء كتابة اسم المستخدم", 200);
            }
            if(!g.create.password || g.create.password == ""){
                return alert("برجاء كتابة كلمة مرور افتراضية", 200);
            }
            $.post(api + '/user/teachers/add', {
                jwt: g.user.jwt,
                name: g.create.name,
                phone: g.create.phone,
                username: g.create.username,
                password: g.create.password,
            }).then(function(r){
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.getTeachers()
                    g.create = {
                        username: Math.random().toString().split('.')[1].substring(0,6).replace('0', '1'),
                        password: makeid(5),
                    }
                    $("#create___BV_modal_header_ > button").click()
                }
            }).fail(function(){
                alert('حدث خطأ في الاتصال', 200)
            })
        },
        editNow(){
            var g = this;
            if(!g.edit.name || g.edit.name == ""){
                return alert("برجاء كتابة اسم المعلم", 200);
            }
            if(!g.edit.username || g.edit.username == ""){
                return alert("برجاء كتابة اسم المستخدم", 200);
            }
            if(!g.edit.password || g.edit.password == ""){
                return alert("برجاء كتابة كلمة مرور افتراضية", 200);
            }
            $.post(api + '/user/teachers/edit', {
                jwt: g.user.jwt,
                id: g.edit._id,
                name: g.edit.name,
                phone: g.edit.phone,
                username: g.edit.username,
                password: g.edit.password,
                max_lessons: g.edit.config.max_lessons
            }).then(function(r){
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.getTeachers()
                    $("#edit___BV_modal_header_ > button").click()
                }
            }).fail(function(){
                alert('حدث خطأ في الاتصال', 200)
            })
        },
        getTeachers(){
            var g = this;
            $.post(api + '/user/teachers/list-s', {
                jwt: g.user.jwt
            }).then(function(r){
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.teachers = r.response;
                }
            }).fail(function(){
                alert('حدث خطأ في الاتصال', 200)
            })
        }
    }
}
</script>

<style>

</style>